<div class="dropdown" dropdown #dropdown="bs-dropdown"
  [insideClick]="true"
  [autoClose]="false"
>
    <!-- Dropdown open button with a globe icon  -->
    <button id="update-status-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle"
       aria-controls="update-status-dropdown-list">
        <ng-container *ngIf="state$ | async as s">
        <ng-container [ngSwitch]="s.status">

          <span *ngSwitchCase="'no-update'" class="ok">
            <i class="fa-solid fa-circle-check"></i>
            {{ getState(s.status) }}
          </span>

          <span *ngSwitchCase="'ready'" class="update">
            <i class="fa-solid fa-circle-arrow-up"></i>
            {{ getState(s.status) }}
          </span>

          <span *ngSwitchCase="'downloading'" class="update">
            <i class="fa-solid fa-circle-arrow-up"></i>
            {{ getState(s.status) }}
          </span>

          <span *ngSwitchCase="'checking'">
            <i class="fa-solid fa-arrows-rotate fa-spin"></i>
            {{ getState(s.status) }}
          </span>

          <span *ngSwitchCase="'failed'" class="error">
            <i class="fa-solid fa-circle-exclamation"></i>
            {{ getState(s.status) }}
          </span>
          <span *ngSwitchDefault class="error">
            <i class="fa-solid fa-circle-exclamation"></i>
            {{ getState(s.status) }}

          </span>

        </ng-container>
        </ng-container>
    </button>
    <!-- Dropdown list of available languages -->

    <ng-container *ngIf="state$ | async as s">
    <div *dropdownMenu class="dropdown-menu dropdown-menu-right px-3 shadow-sm" role="menu">
      <div>
        <b>{{ 'assignment.states.state' | translate}}:</b> {{ getState(s.status) }}
      </div>
      <div *ngIf="s.lastCheckedAt">
        <b>{{'updates.last_checked' | translate}}:</b> {{ s.lastCheckedAt | date:'short' }}
      </div>

      <div *ngIf="s.hasUpdate && s.status !== 'ready'">
        {{ 'updates.searching_for_updates' |  translate }}
      </div>

      <div *ngIf="['ready','downloading'].includes(s.status)">
        <b>{{'updates.new_version_available' | translate}}</b>
        <kupari-button [class]="'btn btn-sm btn-primary'" (onClick)="apply()"
            [text]="'updates.update_now'" [confirmText]="'updates.update_confirmation'" [confirm]="true">
        </kupari-button>
      </div>

      <div *ngIf="s.status === 'failed'">
        <b>{{ 'updates.error' | translate}}:</b> {{ s.error }}
      </div>

      <kupari-button  *ngIf="!['ready','downloading'].includes(s.status)" [class]="'btn btn-sm btn-primary'" (onClick)="check()"
          [text]="'updates.check_for_updates'">
      </kupari-button>
    </div>
    </ng-container>

</div>
